import { useState, useEffect, useMemo } from 'react';
import { useGetAccountsStore } from '@lib/store';
import type { getAccountsResponse } from '@shared/api/rest/accounts';
import { ButtonV2, ItemsType, Modal, MultiRequisites, PrintableContent, PrintStyle, PrintType, Requisites, Select } from '@shared/widgets';
import PrintIcon from '@images/print.svg';

interface TopUpMyAccountModalType {
  account: getAccountsResponse;
  isOpen: boolean;
  onClose: () => void;
}

export const TopUpMyAccountModal = (props: TopUpMyAccountModalType) => {
  const getAccountsStore = useGetAccountsStore();

  const [account, setAccount] = useState<getAccountsResponse>(props.account);
  const [currentSlide, setCurrentSlide] = useState<number>(0);
  const [viewPrintVersion, setViewPrintVersion] = useState(false);

  useEffect(() => {
    if (!props.account) return;
    setAccount(props.account);
  }, [props.account]);

  const accountChangeHandler = (account?: ItemsType) => {
    const selectedAccount = getAccountsStore.data.find((item) => item.Id === account?.value)!;
    setAccount(selectedAccount);
    setCurrentSlide(0);
  };

  const makeSelectData = useMemo(
    () => getAccountsStore.data?.map((item) => ({ value: item.Id, label: item.Amount, leftLabel: item.Currency })),
    [getAccountsStore.data],
  );
  const requisites = useMemo(() => {
    return account?.MultiRequisites?.[currentSlide];
  }, [account, currentSlide]);

  return (
    <Modal title='Top Up My Account' isOpen={props.isOpen} onClose={props.onClose}>
      <div className='w-full'>
        <div className='text-xs font-semibold text-[#929292] uppercase'>Account</div>
        <Select wrapperClassName='!p-0' items={makeSelectData} double value={account?.Id} onChange={accountChangeHandler} />
        <MultiRequisites requisites={account?.MultiRequisites} onSlideChange={setCurrentSlide} />
        <div className='mt-10 flex flex-col gap-6.5'>
          <ButtonV2 className='!h-[56px] gap-2.5' fullWidth onClick={() => setViewPrintVersion(true)}>
            <PrintIcon />
            Print
          </ButtonV2>
          <ButtonV2 className='!h-[56px]' fullWidth color='outlined' onClick={props.onClose}>
            Back
          </ButtonV2>
        </div>
        <PrintableContent
          title={props.account?.Name}
          print={viewPrintVersion}
          onAfterPrint={() => setViewPrintVersion(false)}
          printStyle={PrintStyle.getStyle(PrintType.Table)}
        >
          <Requisites data={{ ...requisites }} />
        </PrintableContent>
      </div>
    </Modal>
  );
};
